import { useEffect, useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import { HelpOutline } from "@mui/icons-material";
import { instance } from "./config";

function InstruccionesModal({ clave }) {
  const [instruccion, setInstruccion] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    instance.get(`/instruccionFormulario/getByClave/${clave}`)
      .then((res) => {
        if (!res.data) return;
        setInstruccion(res.data);

        const key = `instrucciones_vistas_${clave}`;
        if (!sessionStorage.getItem(key)) {
          setOpen(true);
          sessionStorage.setItem(key, "1");
        }
      })
      .catch(() => { });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clave]);

  if (!instruccion) return null;

  return (
    <>
      <Button
        startIcon={<HelpOutline />}
        variant="outlined"
        size="small"
        onClick={() => setOpen(true)}
        sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}
      >
        Ver instrucciones
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{instruccion.Titulo}</DialogTitle>
        <DialogContent dividers>
          <Typography sx={{ whiteSpace: "pre-line" }}>{instruccion.Contenido}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} variant="contained">Cerrar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export { InstruccionesModal };
